import { setupHandleError } from "@canopytax/error-logging";

export const handleError = setupHandleError("cp-client-auth");
